import React from 'react'
import SVG from 'react-inlinesvg'
import PdfHeader from './PdfHeader'

const Sprite = () => (
  <SVG style={{ position: 'absolute', top: '0', left: '0' }} src="/images/svg/sprite.svg" />
)

const PdfLayout = props => {
  return (
    <>
      <PdfHeader />
      {props.children}
      <Sprite />
    </>
  )
}

export default PdfLayout
